import { render, staticRenderFns } from "./PaystubReport.vue?vue&type=template&id=543222b6&scoped=true&"
import script from "./PaystubReport.vue?vue&type=script&lang=ts&"
export * from "./PaystubReport.vue?vue&type=script&lang=ts&"
import style0 from "./PaystubReport.vue?vue&type=style&index=0&id=543222b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543222b6",
  null
  
)

export default component.exports